import React, { useState } from 'react';
import { changeMyPassword } from '../services/api';

const styles = {
  container: {
    minHeight: '100vh',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    background: '#f7fafc',
  },
  card: {
    background: '#fff',
    borderRadius: '12px',
    padding: '40px 48px',
    width: '460px',
    boxShadow: '0 10px 40px rgba(0,0,0,0.1)',
  },
  heading: { fontSize: '22px', fontWeight: '700', marginBottom: '8px', color: '#1a202c' },
  subheading: { fontSize: '14px', color: '#718096', marginBottom: '24px', lineHeight: '1.45' },
  label: { display: 'block', fontSize: '14px', fontWeight: '600', color: '#4a5568', marginBottom: '6px', marginTop: '14px' },
  input: {
    width: '100%', padding: '12px 16px', border: '2px solid #e2e8f0', borderRadius: '8px',
    fontSize: '16px', outline: 'none', boxSizing: 'border-box',
  },
  button: {
    width: '100%', padding: '14px', background: '#9C3D97', color: '#fff', border: 'none',
    borderRadius: '8px', fontSize: '16px', fontWeight: '600', cursor: 'pointer',
    marginTop: '20px',
  },
  signOutBtn: {
    width: '100%', padding: '10px', background: 'transparent', color: '#718096',
    border: 'none', fontSize: '13px', cursor: 'pointer', marginTop: '8px',
  },
  error: {
    background: '#fed7d7', color: '#c53030', padding: '12px', borderRadius: '8px',
    marginBottom: '16px', fontSize: '14px',
  },
  notice: {
    background: '#fefcbf', color: '#744210', padding: '12px',
    border: '1px solid #ecc94b', borderRadius: '8px',
    marginBottom: '16px', fontSize: '13px', lineHeight: '1.5',
  },
};

const MIN_LENGTH = 8;

export default function ChangePasswordPage({ email, onSuccess, onSignOut }) {
  const [oldPassword, setOldPassword] = useState('');
  const [newPassword, setNewPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  async function handleSubmit(e) {
    e.preventDefault();
    setError('');

    const oldPw = oldPassword.trim();
    const newPw = newPassword.trim();
    const confirmPw = confirmPassword.trim();

    if (newPw.length < MIN_LENGTH) {
      setError(`New password must be at least ${MIN_LENGTH} characters.`);
      return;
    }
    if (newPw !== confirmPw) {
      setError('New password and confirmation do not match.');
      return;
    }
    if (newPw === oldPw) {
      setError('New password must be different from the temporary password.');
      return;
    }

    setLoading(true);
    try {
      const result = await changeMyPassword(email, oldPw, newPw);
      if (result && result.error) {
        setError(result.error);
      } else {
        onSuccess();
      }
    } catch {
      setError('Unable to connect.');
    } finally {
      setLoading(false);
    }
  }

  return (
    <div style={styles.container}>
      <div style={styles.card}>
        <div style={{ textAlign: 'center', marginBottom: '20px' }}>
          <img src="/hellorache-logo.jpg" alt="HelloRache" style={{ height: '44px' }} />
        </div>
        <h1 style={styles.heading}>Set a new password</h1>
        <p style={styles.subheading}>
          You're signed in as <strong>{email}</strong>. Before you can use the portal, please replace your temporary password with one only you know.
        </p>
        <div style={styles.notice}>
          Tip: paste the temporary password if you have it on your clipboard. We strip any trailing whitespace automatically.
        </div>
        {error && <div style={styles.error}>{error}</div>}
        <form onSubmit={handleSubmit}>
          <label style={styles.label}>Current (temporary) password</label>
          <input
            style={styles.input}
            type="password"
            value={oldPassword}
            onChange={(e) => setOldPassword(e.target.value)}
            required
            autoFocus
          />
          <label style={styles.label}>New password</label>
          <input
            style={styles.input}
            type="password"
            value={newPassword}
            onChange={(e) => setNewPassword(e.target.value)}
            required
            minLength={MIN_LENGTH}
          />
          <label style={styles.label}>Confirm new password</label>
          <input
            style={styles.input}
            type="password"
            value={confirmPassword}
            onChange={(e) => setConfirmPassword(e.target.value)}
            required
            minLength={MIN_LENGTH}
          />
          <button
            style={{ ...styles.button, opacity: loading ? 0.6 : 1 }}
            type="submit"
            disabled={loading}
          >
            {loading ? 'Updating...' : 'Update password and continue'}
          </button>
        </form>
        <button style={styles.signOutBtn} onClick={onSignOut}>Sign out</button>
      </div>
    </div>
  );
}
